package link.erpango.quip.data.firebase.auth

import kotlinx.coroutines.CoroutineScope
import link.erpango.quip.core.auth.IFirebaseUserWrapper
import link.erpango.quip.data.firebase.IFirebaseClient

class FirebaseAuth(
    private val client: IFirebaseClient
): IFirebaseAuth{

    val user: IFirebaseUserWrapper?
        get() = client.getCurrentUser()

    fun signIn(email: String, password: String) {
        return client.signIn(email, password)
    }

    fun signOut(scope: CoroutineScope) {
        return client.signOut()
    }

    fun signUp(email: String, password: String) {
        return client.signUp(email, password)
    }

    fun resetPassword(email: String) {
        return client.resetPassword(email)
    }

    fun getCurrentUser(): IFirebaseUserWrapper? {
        return client.getCurrentUser()
    }
}